import React, { useEffect } from "react";
import { useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    Table,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWithdrawalRequests, requestWithdrawal, getWallet, getBankDetails } from "../../store/slices/user";


export default function UserWithdrawal() {
    const dispatch = useDispatch();

    const { wallet, withdrawalRequests, bankDetails, loading } = useSelector(
        (state) => state.user
    );
    const [selectedBankAccount, setSelectedBankAccount] = useState("");

    const [amount, setAmount] = useState("");
    const [amountError, setAmountError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 5;

    useEffect(() => {
        dispatch(getWallet());
        dispatch(getWithdrawalRequests());
        dispatch(getBankDetails());
    }, [dispatch]);

    const withdrawalData = withdrawalRequests || [];

    const totalPages = Math.ceil(
        withdrawalData.length / itemsPerPage
    );

    const currentData = withdrawalData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const verifiedBankAccounts =
        bankDetails?.filter((item) => item.isVerified) || [];

    const selectedAccount =
        verifiedBankAccounts.find(
            (item) => item._id === selectedBankAccount
        );



    useEffect(() => {
        if (
            verifiedBankAccounts.length > 0 &&
            !selectedBankAccount
        ) {
            setSelectedBankAccount(
                verifiedBankAccounts[0]._id
            );
        }
    }, [verifiedBankAccounts, selectedBankAccount]);

    const validateWithdrawalAmount = (value) => {
        const enteredAmount = Number(value);
        const availableBalance = Number(wallet?.availableBalance || 0);

        if (!value) {
            return "Please enter withdrawal amount";
        }

        if (enteredAmount < 500) {
            return "Minimum withdrawal amount is ₹500";
        }

        if (enteredAmount % 100 !== 0) {
            return "Amount must be in multiples of ₹100";
        }

        if (enteredAmount > availableBalance) {
            return "Amount cannot exceed available wallet balance";
        }

        return "";
    };

    const handleWithdraw = async () => {
        const error = validateWithdrawalAmount(amount);

        if (error) {
            setAmountError(error);
            return;
        }

        const result = await dispatch(
            requestWithdrawal({
                amount: Number(amount),
                bankAccountId: selectedAccount?._id,
            })
        );

        if (requestWithdrawal.fulfilled.match(result)) {
            setAmount("");
            setAmountError("");

            dispatch(getWallet());
            dispatch(getWithdrawalRequests());
        }
    };


    return (

        <>

            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/user/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"
                            // onClick={() => navigate("/user/withdraw")}
                            >
                                Withdraw funds
                            </span>
                        </div>



                    </div>
                </div>
            </div>


            <div className="withdrawal-page-wrapper">

                <Container fluid>

                    <Row className="justify-content-center">

                        <Col xl={12} lg={12}>

                            <Card className="withdraw-form-card">

                                <div className="withdraw-form-top ">

                                    <div>

                                        <h3>
                                            Withdraw Funds
                                        </h3>

                                        <small className="text-muted">
                                            Minimum ₹500 • Amount should be in multiples of ₹100 • Maximum ₹{Number(wallet?.availableBalance || 0)}
                                        </small>

                                    </div>

                                    <div className="balance-card-box">

                                        <span>
                                            Available Balance
                                        </span>

                                        <h2>
                                            ₹{Number(wallet?.availableBalance || 0).toFixed(2)}
                                        </h2>

                                    </div>

                                </div>

                                <Form>

                                    <Row className="g-4">

                                        <Col md={12}>

                                            <Form.Group>

                                                <Form.Label>
                                                    Withdrawal Amount
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    min="500"
                                                    step="100"
                                                    value={amount}
                                                    placeholder="Enter Amount"
                                                    className="withdraw-input"
                                                    isInvalid={!!amountError}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/\D/g, "");

                                                        setAmount(value);

                                                        setAmountError(
                                                            validateWithdrawalAmount(value)
                                                        );
                                                    }}
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {amountError}
                                                </Form.Control.Feedback>

                                            </Form.Group>

                                        </Col>



                                        <Col md={12}>

                                            <Form.Group>

                                                <Form.Label>
                                                    Account Number
                                                </Form.Label>

                                                <Form.Select
                                                    value={selectedBankAccount}
                                                    onChange={(e) =>
                                                        setSelectedBankAccount(e.target.value)
                                                    }
                                                    className="withdraw-input"
                                                >
                                                    {verifiedBankAccounts.length === 0 ? (
                                                        <option value="">
                                                            No verified bank account found
                                                        </option>
                                                    ) : (
                                                        verifiedBankAccounts.map((account) => (
                                                            <option
                                                                key={account._id}
                                                                value={account._id}
                                                            >
                                                                {account.bankName} - XXXX
                                                                {account.accountNumber.slice(-4)}
                                                            </option>
                                                        ))
                                                    )}
                                                </Form.Select>
                                            </Form.Group>

                                        </Col>

                                    </Row>

                                    <div className="d-flex justify-content-center align-items-center mt-3">

                                        <Button
                                            className="withdraw-btn"
                                            disabled={
                                                verifiedBankAccounts.length === 0 ||
                                                loading
                                            }
                                            onClick={handleWithdraw}
                                        >
                                            Withdraw Now
                                        </Button>

                                    </div>

                                </Form>

                            </Card>

                        </Col>

                    </Row>

                    <Row>
                        <div className="p-3">
                            <h5 className="mb-0">
                                Wallet Transactions
                            </h5>
                        </div>
                    </Row>

                    <Card className="ud-table-card mt-4 mb-5">



                        <div className="ud-scroll-wrap">

                            <Table className="ud-table align-middle mb-0">

                                <thead>

                                    <tr>
                                        <th>#</th>
                                        <th>Amount</th>
                                        <th>Account Number</th>

                                        <th>Bank</th>
                                        <th>Request Date</th>
                                        <th>Approval Date</th>
                                        <th>Status</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {currentData?.map((item, index) => (
                                        <tr key={item._id}>
                                            <td>
                                                {(currentPage - 1) * itemsPerPage + index + 1}
                                            </td>

                                            <td>₹{item?.amount || 0}</td>

                                            <td>
                                                {item?.bankAccountId?.accountNumber
                                                    ? `XXXX${item.bankAccountId.accountNumber.slice(-4)}`
                                                    : "-"}
                                            </td>

                                            <td>
                                                {item?.bankAccountId?.bankName || "-"}
                                            </td>

                                            <td>
                                                {item?.createdAt
                                                    ? new Date(item.createdAt).toLocaleDateString("en-IN")
                                                    : "-"}
                                            </td>

                                            <td>
                                                {item?.approvedAt
                                                    ? new Date(item.approvedAt).toLocaleDateString("en-IN")
                                                    : "-"}
                                            </td>

                                            <td>
                                                <span
                                                    className={`ud-status-badge ${item?.status === "APPROVED"
                                                        ? "ud-status-active"
                                                        : item?.status === "REJECTED"
                                                            ? "ud-status-rejected"
                                                            : "ud-status-pending"
                                                        }`}
                                                >
                                                    {item?.status || "PENDING"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>

                            </Table>

                        </div>

                    </Card>

                    {totalPages > 1 && (

                        <div className="ud-pagination-wrap">

                            <Pagination className="ud-pagination">

                                <Pagination.Prev
                                    disabled={currentPage === 1}
                                    onClick={() =>
                                        setCurrentPage((prev) => prev - 1)
                                    }
                                />

                                {[...Array(totalPages)].map((_, index) => (

                                    <Pagination.Item
                                        key={index + 1}
                                        active={currentPage === index + 1}
                                        onClick={() =>
                                            setCurrentPage(index + 1)
                                        }
                                    >
                                        {index + 1}
                                    </Pagination.Item>

                                ))}

                                <Pagination.Next
                                    disabled={currentPage === totalPages}
                                    onClick={() =>
                                        setCurrentPage((prev) => prev + 1)
                                    }
                                />

                            </Pagination>

                        </div>

                    )}

                </Container>

            </div>
        </>
    );
}